import { render, staticRenderFns } from "./PersonalIncomeStatementCN.vue?vue&type=template&id=8c375b6e"
import script from "./PersonalIncomeStatementCN.vue?vue&type=script&lang=js"
export * from "./PersonalIncomeStatementCN.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports